import React from "react";
import InfoIcon from "../../../../../styles/img/svg/InfoIcon";
import HeartIcon from "../../../../../styles/img/svg/HeartIcon";
import EntryRightIcon from "../../../../../styles/img/svg/EntryRightIcon";
import PropTypes from "prop-types";

export function UiSalesChainElementWr(props) {
    return (
        <>
            <div className="sb-sales-chain">
                <ul>{props.children}</ul>
            </div>
        </>
    );
}

export function UiSalesChainElement(props) {
    return (
        <>
            <li
                className={
                    props.isActive
                        ? "sb-sales-active"
                        : "" || props.isEntryActive
                        ? "sb-sales-active-entry"
                        : ""
                }
            >
                <div className="sb-sales-chain__icon">
                    {props.isActive ? (
                        <HeartIcon />
                    ) : (
                        !props.isEntryActive && <InfoIcon />
                    )}
                    {props.isEntryActive && <EntryRightIcon />}
                </div>
                <div className="sb-sales-chain__content">
                    <div className="sb-sales-chain__left">
                        <label>{props.salesContent}</label>
                    </div>
                    <div className="sb-sales-chain__right">
                        <div className="sb-sales-chain__date">
                            {props.value}
                        </div>
                    </div>
                </div>
            </li>
        </>
    );
}

export function UiListViewChainElement(props) {
    const { winnerImage,name,content,date,reward } = props;
    return (
        <>
            <div className="sb-spin-winners-list">
                <div className="sb-spin-winners-list__img">
                    <img src={winnerImage}/>
                </div>
                <div className="sb-spin-winners-list__content">
                    <div className="sb-spin-winners-list__content-left">
                        <label>{name}</label>
                        <span>{content}</span>
                    </div>
                    <div className="sb-spin-winners-list__content-right">
                        {props.reward &&
                            <div className="sb-spin-winners-list__reward">
                                {reward}
                            </div>
                        }
                        {props.date &&
                            <div className="sb-spin-winners-list__date">
                                {date}
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export function UiSalesChainElementNoBgWr(props) {
    return (
        <>
            <div className="sb-sales-chain sb-sales-chain-no-bg">
                <ul>{props.children}</ul>
            </div>
        </>
    );
}

export function UiWinnersListViewChainElement(props) {
    const { winnerImage,name,content,date,reward } = props;
    return (
        <>
            <div className="sb-prize-draw-winners-list">
                <div className="sb-prize-draw-winners-list__img">
                    <img src={winnerImage}/>
                </div>
                <div className="sb-prize-draw-winners-list__content">
                    <div className="sb-prize-draw-winners-list__content-left">
                        <label>{name}</label>
                        <span>{content}</span>
                    </div>
                    <div className="sb-prize-draw-winners-list__content-right">
                        {props.reward &&
                            <div className="sb-prize-draw-winners-list__reward">
                                £ {reward}
                            </div>
                        }
                       
                    </div>
                </div>
            </div>
        </>
    );
}

UiSalesChainElement.propTypes = {
    isActive: PropTypes.bool,
    salesStatus: PropTypes.string,
    salesId: PropTypes.string,
    date: PropTypes.string,
};
